import * as actions from './actions';

const initialState = {
  runes: [],
  runesLoading: false,
  runesError: null,

  indexReading: null,
  indexLoading: false,
  indexError: null,
  indexLiked: false,

  trialLoading: false,
  trialSent: false,
  trialError: null,

  threeRuneReading: null,
  threeRuneLoading: false,
  threeRuneError: null,

  // Anonymous per-reading purchase
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
  paidReading: null,
};

export default function runasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_RUNES_REQUEST:
      return { ...state, runesLoading: true, runesError: null };
    case actions.FETCH_RUNES_SUCCESS:
      return { ...state, runesLoading: false, runes: action.payload.runes };
    case actions.FETCH_RUNES_FAILURE:
      return { ...state, runesLoading: false, runesError: action.payload.error };

    case actions.GET_INDEX_READING_REQUEST:
      return { ...state, indexLoading: true, indexError: null, indexReading: null };
    case actions.GET_INDEX_READING_SUCCESS:
      return { ...state, indexLoading: false, indexReading: action.payload.reading };
    case actions.GET_INDEX_READING_FAILURE:
      return { ...state, indexLoading: false, indexError: action.payload.error };
    case actions.RESET_INDEX_READING:
      return { ...state, indexReading: null, indexError: null, indexLiked: false };

    case actions.SET_INDEX_READING_LIKE_SUCCESS:
      return { ...state, indexLiked: true };

    case actions.REQUEST_THREE_RUNE_EMAIL_REQUEST:
      return { ...state, trialLoading: true, trialError: null, trialSent: false };
    case actions.REQUEST_THREE_RUNE_EMAIL_SUCCESS:
      return { ...state, trialLoading: false, trialSent: true };
    case actions.REQUEST_THREE_RUNE_EMAIL_FAILURE:
      return { ...state, trialLoading: false, trialError: action.payload.error };

    case actions.CREATE_THREE_RUNE_REQUEST:
      return { ...state, threeRuneLoading: true, threeRuneError: null, threeRuneReading: null };
    case actions.CREATE_THREE_RUNE_SUCCESS:
      return { ...state, threeRuneLoading: false, threeRuneReading: action.payload.reading };
    case actions.CREATE_THREE_RUNE_FAILURE:
      return { ...state, threeRuneLoading: false, threeRuneError: action.payload.error };
    case actions.RESET_THREE_RUNE:
      return { ...state, threeRuneReading: null, threeRuneError: null };

    case actions.CREATE_PENDING_THREE_RUNE_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null };
    case actions.CREATE_PENDING_THREE_RUNE_SUCCESS:
      return { ...state, pendingLoading: false, pendingReadingId: action.payload.readingId };
    case actions.CREATE_PENDING_THREE_RUNE_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.RUNAS_CHECKOUT_REQUEST:
    case actions.RUNAS_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.RUNAS_CHECKOUT_SUCCESS:
    case actions.RUNAS_PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.RUNAS_CHECKOUT_FAILURE:
    case actions.RUNAS_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.RUNAS_VERIFY_REQUEST:
    case actions.RUNAS_VERIFY_PAYPAL_REQUEST:
      return { ...state, threeRuneLoading: true, checkoutError: null };
    case actions.RUNAS_VERIFY_SUCCESS:
    case actions.RUNAS_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        threeRuneLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
        paidReading: action.payload.reading || state.paidReading,
      };
    case actions.RUNAS_VERIFY_FAILURE:
    case actions.RUNAS_VERIFY_PAYPAL_FAILURE:
      return { ...state, threeRuneLoading: false, checkoutError: action.payload };

    default:
      return state;
  }
}
